import { render } from "./PageSp.vue?vue&type=template&id=0cb9f25e&scoped=true"
import script from "./PageSp.vue?vue&type=script&lang=js"
export * from "./PageSp.vue?vue&type=script&lang=js"

import "./PageSp.vue?vue&type=style&index=0&id=0cb9f25e&scoped=true&lang=css"

import exportComponent from "/home/pslcal/meruhensya.com/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb9f25e"]])

export default __exports__